//--- Import Export Config here
export const WMS = "https://cargis.vn:8440/geoserver/hatinh2021/wms/";
export const APIUrl = "https://api.cargis.vn";
export const AdminUrl = "https://admin.cargis.vn";
